module.exports = __webpack_public_path__ + "img/5.260ebd61.jpg";